// sentry.server.config.js
import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  ignoreErrors: [
    // Ignore specific error messages
    '$("#disclaimer").modal is not a function',
    "bootstrap.min.js",
    "$ is not defined",
    'Could not load "util"',
    "t is not a function",
    "t.map is not a function",
    "'t' is undefined",
    "$(...).modal is not a function",
  ],
});
